import { render, staticRenderFns } from "./FormSubmissionsDetails.vue?vue&type=template&id=39f57f7a&"
import script from "./FormSubmissionsDetails.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports